import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Link from 'components/common/Link';

import IconButton from 'components/common/IconButton';
import IconArrowHeadBottom from 'components/icons/IconArrowHeadBottom';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';

import { fetchClaimAttachmentStatus } from 'redux/modules/claims';

import timeDateFormat from 'config/timeDateFormat';

const styles = theme => ({
  button: {
    margin: -16,
    verticalAlign: 'middle',
  },
  iconArrowHeadBottom: {
    width: 12,
    height: 8,
  },
  iconArrowHeadBottomDiffOpen: {
    transform: 'rotate(180deg)',
  },
  tableCellDate: {
    width: 120,
    whiteSpace: 'nowrap',
  },
  tableCellActions: {
    width: 16,
    paddingRight: 29,
    '&:last-child': {
      paddingRight: 29,
    },
  },
  tableRow: {
    '&:first-child $tableCell': {
      borderTop: 'none',
    },
  },
  tableRowDiffOpen: {
    height: 35,
  },
  tableCell: {
    borderBottom: 'none',
    borderTop: `1px solid ${theme.palette.primary.A400}`,
  },
  tableCellStatus: {
    padding: '0 0 0 16px',
    borderTop: `1px solid ${theme.palette.primary.A400}`,
    '&:last-child': {
      paddingRight: 0,
    },
  },
  tableRowStatus: {
    backgroundColor: theme.palette.grey[100],
  },
  iconRefresh: {
    width: 12,
    height: 12,
  },
  iconRefreshLoading: {
    color: theme.palette.primary[500],
  },
  buttonRefresh: {
    position: 'relative',
    top: 1,
    margin: '-18px -18px -18px -12px',
  },
  status: {
    display: 'inline-block',
    marginRight: 4,
    textTransform: 'capitalize',
  },
  statusSuccess: {
    color: theme.palette.active[800],
  },
  tableCellStatusCode: {
    whiteSpace: 'nowrap',
  },
  tableCellStatusMessage: {
    width: '90%',
  },
});

class AttachmentsTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusOpen: false,
    };

    this.onStatusButtonClick = this.onStatusButtonClick.bind(this);
  }

  onStatusButtonClick() {
    const { actions, Extra, Status } = this.props;
    if (!Status) {
      actions.fetchClaimAttachmentStatus({
        values: {
          'Trace ID': Extra.response.attachmentId,
        },
      });
    }
    this.setState({ statusOpen: !this.state.statusOpen });
  }

  render() {
    const {
      business,
      Extra,
      Status,
      onAttachmentView,
      classes,
      ...otherProps
    } = this.props;
    const { statusOpen } = this.state;
    return (
      <Fragment>
        <TableRow
          className={classes.tableRow}
        >
          <TableCell
            className={classNames(classes.tableCell, classes.tableCellDate)}
          >
            {formatUtcToLocalDate(
              otherProps['Create At'],
              timeDateFormat,
              timeDateFormat,
              business['Company Address']['Time Zone'],
              business['Company Address']['Observes Daylight Saving'],
            )}
          </TableCell>
          <TableCell
            className={classes.tableCell}
          >
            {(Extra && Extra.error) ? (
              Extra.error
            ) : (
              <span
                className={classNames(classes.status, {
                  [classes.statusSuccess]: Extra.response.status === 'success',
                })}
              >
                {Extra.response.status}
              </span>
            )}
          </TableCell>
          <TableCell
            className={classes.tableCell}
          >
            {(Extra && Extra.response && Extra.response.attachmentId) && (
              Extra.response.attachmentId
            )}
          </TableCell>
          <TableCell
            className={classes.tableCell}
          >
            {(Extra && Extra.cmn && Extra.cmn['File Name']) && (
              <Link
                onClick={() => onAttachmentView({
                  cmn: Extra.cmn,
                  response: Extra.response,
                })}
              >
                {Extra.cmn['File Name']}
              </Link>
            )}
          </TableCell>
          <TableCell
            className={classNames(classes.tableCell)}
          >
            {(Extra && Extra.response && Extra.response.attachmentId) && (
              <IconButton
                className={classes.buttonRefresh}
                onClick={this.onStatusButtonClick}
                tooltipContent="Show more"
              >
                <IconArrowHeadBottom
                  className={classNames(classes.iconArrowHeadBottom, {
                    [classes.iconArrowHeadBottomDiffOpen]: statusOpen,
                  })}
                />
              </IconButton>
            )}
          </TableCell>
        </TableRow>
        {(statusOpen && Status) && (
          <TableRow className={classNames(classes.tableRow, classes.tableRowStatus)}>
            <TableCell
              className={classes.tableCellStatus}
              colSpan="5"
            >
              <Table>
                <TableBody>
                  {Status.Extra.response.status.map(statusItem => (
                    <TableRow
                      className={classes.tableRow}
                      key={statusItem.statusTimeStamp}
                    >
                      <TableCell
                        className={classNames(classes.tableCell, classes.tableCellDate)}
                      >
                        {formatUtcToLocalDate(
                          moment(statusItem.statusTimeStamp).format(timeDateFormat),
                          timeDateFormat,
                          timeDateFormat,
                          business['Company Address']['Time Zone'],
                          business['Company Address']['Observes Daylight Saving'],
                        )}
                      </TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.tableCellStatusCode)}
                      >
                        Status Code:
                        {statusItem.statusCode}
                      </TableCell>
                      <TableCell
                        className={classNames(classes.tableCell, classes.tableCellStatusMessage)}
                      >
                        {statusItem.statusMessage}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>
        )}
      </Fragment>
    );
  }
}

AttachmentsTableRow.propTypes = {
  'Create At': PropTypes.string.isRequired,
  onAttachmentView: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    fetchClaimAttachmentStatus: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  Extra: PropTypes.shape({
    response: PropTypes.shape({
      attachmentId: PropTypes.string,
    }),
  }),
  Status: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    iconArrowHeadBottom: PropTypes.string.isRequired,
    iconArrowHeadBottomDiffOpen: PropTypes.string.isRequired,
    tableCell: PropTypes.string.isRequired,
    tableCellDate: PropTypes.string.isRequired,
    tableCellActions: PropTypes.string.isRequired,
    tableRowDiffOpen: PropTypes.string.isRequired,
  }).isRequired,
};

AttachmentsTableRow.defaultProps = {
  business: {},
  Extra: null,
  Status: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchClaimAttachmentStatus }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(AttachmentsTableRow),
);



// WEBPACK FOOTER //
// ./src/components/reports/AttachmentsDialog/AttachmentsTableRow.js